module.exports = __webpack_public_path__ + "fonts/StagSans-Light-Italic.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Light-Italic.otf
// module id = 1086
// module chunks = 0